class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "1"
    }
  }
  async _init() {
    return true
  }

  async get() {
    return "1"
  }
  async set() {
    return true
  }
}

export default Source
